import { render, staticRenderFns } from "./concerns.vue?vue&type=template&id=3ae89143&"
import script from "./concerns.vue?vue&type=script&lang=js&"
export * from "./concerns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports